module.exports = __webpack_public_path__ + "img/平贝母.933e0d47.jpg";